import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILoaderState } from 'src/types/Loader';

const initialState: ILoaderState = {
  isLoading: false,
  isProgress: false
};

export const loader = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    hideLoader: state => {
      state.isLoading = false;
    },
    showLoader: state => {
      state.isLoading = true;
    },
    setProgress: (state, action: PayloadAction<boolean>) => {
      state.isProgress = action.payload;
    },
    showProgress: state => {
      state.isProgress = true;
    },
    hideProgress: state => {
      state.isProgress = false;
    },
    clearLoader: state => {
      state.isLoading = false;
      state.isProgress = false;
    }
  }
});

export const { hideLoader, showLoader, showProgress, clearLoader, hideProgress, setProgress } = loader.actions;
